import React, { useEffect, useRef, useState } from 'react';
import IconCamera from './icon/IconCamera';
import IconRefresh from './icon/IconRefresh';

interface CameraComponentProps {
    onCapture: (imageSrc: string) => void;
}

const CameraComponent: React.FC<CameraComponentProps> = ({ onCapture }) => {
    const videoRef = useRef<HTMLVideoElement>(null);
    const [stream, setStream] = useState<MediaStream | null>(null);
    const [loading, setLoading] = useState(true);
    const [cameraFacing, setCameraFacing] = useState<'user' | 'environment'>('environment');

    const onFlipCamera = () => {
        setCameraFacing((prev) => (prev === 'environment' ? 'user' : 'environment'));
    };

    useEffect(() => {
        const getCameraStream = async () => {
            try {
                if (stream) {
                    stream.getTracks().forEach((track) => track.stop());
                }

                const newStream = await navigator.mediaDevices.getUserMedia({
                    video: { facingMode: cameraFacing }
                });

                if (videoRef.current) {
                    videoRef.current.srcObject = newStream;
                }

                setStream(newStream);
                setLoading(false);
            } catch (error) {
                console.error("Error accessing camera", error);
                setLoading(false);
            }
        };

        getCameraStream();

        return () => {
            if (stream) {
                stream.getTracks().forEach((track) => track.stop());
            }
        };
    }, [cameraFacing])

    const handleCapture = () => {
        if (!videoRef.current) return;

            const canvas = document.createElement('canvas');
            canvas.width = videoRef.current.videoWidth;
            canvas.height = videoRef.current.videoHeight;
            const context = canvas.getContext('2d');
            if (context) {
                context.drawImage(videoRef.current, 0, 0, canvas.width, canvas.height);
                const imageSrc = canvas.toDataURL('image/jpeg');
                onCapture(imageSrc);
            }
    };

    return (
    <div className="relative">
        {loading && (
            <div className="absolute inset-0 flex items-center justify-center bg-white bg-opacity-70 z-10">
            <div className="animate-spin w-10 h-10 border-4 border-blue-500 border-t-transparent rounded-full"></div>
            </div>
        )}
        <video
            ref={videoRef}
            autoPlay
            playsInline
            muted
            className="w-full"
        />
        <div className="flex my-4 items-center justify-center">
            <div onClick={()=>{handleCapture()}} className="-right-8 ml-auto btn btn-sm btn-primary">
                <IconCamera className="w-10 h-10"/>
            </div>
            <button onClick={()=>{onFlipCamera()}} className="btn btn-sm btn-outline-primary hover:bg-transparent hover:text-primary ml-auto mr-8">
                <IconRefresh />
            </button>
            
        </div>
    </div>
    );
};

export default CameraComponent;
